import "./style.scss";

import { CircularProgress } from "@mui/material";
import type { ReactNode } from "react";

/**
 * Status popup, blue color when pending, green when succeeded
 */
interface IDynamicStatus {
    data: any;
    activeText: string;
    defaultText: string;
    renderStatusRight: ReactNode;
    pending: boolean;
    succeeded: boolean;
}

const DynamicStatus = ({ data, activeText, defaultText, renderStatusRight, pending, succeeded }: IDynamicStatus) => {
    return (
        <div className={`dynamic-status-wrapper ${succeeded ? "succeeded" : ""}`}>
            <div className="dynamic-status-left">
                <div className="status-chip" />
                <span>{data ? activeText : defaultText}</span>
            </div>
            <div className="dynamic-status-right">
                {pending ? <CircularProgress className="pending-icon" /> : renderStatusRight}
            </div>
        </div>
    );
};

export default DynamicStatus;
